import { postApi } from "../apis";

export const addJob = (data) => {
    return postApi('/api/postJob', data);
};